import React from 'react'

import {
  SvgIcon
} from '../'

export default class SplitView extends React.Component {
  state = {
    toggle: false
  }

  render() {
    return (
      <div id="render" style={{ padding: 16 }}>
        <div style={{ display: "flex", width: 320, height: 800 }}>
          <div className={`slds-split-view_container ${this.state.toggle ? "slds-is-open" : "slds-is-closed"}`}>
            <button
              className="slds-button slds-button_icon slds-button_icon slds-split-view__toggle-button"
              onClick={() => this.setState({ toggle: !this.state.toggle})}
              aria-expanded="true"
              aria-controls="split-view-id"
              title={this.state.toggle ? "Close" : "Open"}>
              <SvgIcon
                variant='utility'
                symbol='left'
                size='small'
              />
              <span className="slds-assistive-text">{this.state.toggle ? "Close" : "Open"}</span>
            </button>
            <article aria-hidden="false" id="split-view-id" className="slds-split-view slds-grid slds-grid_vertical slds-grow">

            </article>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/split-view/index.js